<template>
    <div>
        <pc-textarea
            v-model.trim="content"
            v-bind:maxlength="contentMaxLength"
            v-bind:label="contentTextAreaLabel" />
        <div class="d-flex align-items-center justify-content-end mb-3">
            <div class="text-body-secondary fst-italic small">
                <span>
                    {{ remainingCharsLabel }}
                </span>
                <span>
                    {{ contentRemainingChars }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/userFeedbackDialog.i18n";

    const CONTENT_LENGTH_LIMIT = 4000;

    export const HOOKS = {
        getResultData: "getResultData"
    };

    export const RESULTS = {
        ok: "OK",
        cancel: "CANCEL"
    };

    export default {
        props: {
            /**
             * True if user deliberately initiated giving feedback, false if we
             * forced them to see it while trying to do something else
             */
            isVoluntary: { type: Boolean, required: false, default: true },
            labelOverride: { type: String, required: false, default: null }
        },
        data() {
            return {
                content: null,
                contentMaxLength: CONTENT_LENGTH_LIMIT
            };
        },
        computed: {
            contentTextAreaLabel() {
                return this.labelOverride
                    ? this.labelOverride
                    : this.isVoluntary
                      ? this.contentTextAreaLabelVoluntary
                      : this.contentTextAreaLabelInvoluntary;
            },
            contentRemainingChars() {
                const contentLength = this.content ? this.content.length : 0;
                const diff = CONTENT_LENGTH_LIMIT - contentLength;
                return diff >= 0 ? diff : 0;
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        methods: {
            [HOOKS.getResultData](result) {
                if (result === RESULTS.cancel) {
                    return null;
                }

                return {
                    Content: this.content,
                    Browser: navigator.sayswho // Initialized by the errorReporter
                };
            }
        }
    };
</script>
